export default function ActivateReportIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M21 7H3M21 7V13C21 16.771 20.999 18.656 19.828 19.828C18.657 21 16.771 21 13 21H11C7.229 21 5.344 20.999 4.172 19.828C3 18.657 3 16.771 3 13V7M21 7L19.8 5.4C18.917 4.222 18.475 3.633 17.842 3.317C17.208 3 16.472 3 15 3H9C7.528 3 6.792 3 6.158 3.317C5.525 3.633 5.083 4.222 4.2 5.4L3 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11V17.5M9 13.5C9.59 12.893 11.16 10.5 12 10.5C12.84 10.5 14.41 12.893 15 13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
